import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
var CustomerAttendantFormComponent = /** @class */ (function () {
    function CustomerAttendantFormComponent(errorsService, formBuilder, customerAttendantService, snackBar, router, route) {
        this.errorsService = errorsService;
        this.formBuilder = formBuilder;
        this.customerAttendantService = customerAttendantService;
        this.snackBar = snackBar;
        this.router = router;
        this.route = route;
    }
    CustomerAttendantFormComponent.prototype.ngOnInit = function () {
        this.id = this.route.snapshot.paramMap.get('id');
        this.initForm();
    };
    CustomerAttendantFormComponent.prototype.initForm = function () {
        this.formGroup = this.formBuilder.group({
            firstName: [null, [Validators.required]],
            lastName: [null, [Validators.required]],
            phoneNumber: [null, [Validators.required]],
        });
        if (this.id) {
            this.loadInfos().catch(function (err) { return console.log(err); });
        }
    };
    CustomerAttendantFormComponent.prototype.loadInfos = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.customerAttendantService.findOne(this.id).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.formGroup.patchValue({
                                    firstName: response.firstName,
                                    lastName: response.lastName,
                                    phoneNumber: response.phoneNumber,
                                });
                                return [2 /*return*/];
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerAttendantFormComponent.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.formGroup.valid) {
                    this.snackBar.open('Preencha corretamente os campos e tente novamente.');
                    return [2 /*return*/, false];
                }
                data = {
                    firstName: this.formGroup.value.firstName,
                    lastName: this.formGroup.value.lastName,
                    phoneNumber: this.formGroup.value.phoneNumber,
                };
                if (this.id) {
                    this.customerAttendantService.update(this.id, data).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!response.isUpdated) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.router.navigate(['./dashboard/attendant'])];
                                case 1:
                                    _a.sent();
                                    this.snackBar.open('Atendente atualizada com sucesso.');
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); }, function (error) {
                        _this.snackBar.open(error.error.message);
                    });
                }
                else {
                    this.customerAttendantService.create(data).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!response.isCreated) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.router.navigate(['./dashboard/attendant'])];
                                case 1:
                                    _a.sent();
                                    this.snackBar.open('Atendente criado com sucesso.');
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); }, function (error) {
                        _this.snackBar.open(error.error.message);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return CustomerAttendantFormComponent;
}());
export { CustomerAttendantFormComponent };
